import React from 'react';
import styled from 'styled-components';
import { Flex, Text, Loading } from '../components';
import '../../../assets/css/spinner.css';
import { PageTitle } from '../biz-components/page-title';

class FillFormAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    const timer = setInterval(this.props.checkActionStatus, 3000);
    this.setState({ timer });
  }

  componentWillUnmount() {
    const { timer } = this.state;
    clearInterval(timer);
  }

  renderNotSubmitted() {
    return (
      <Flex column>
        <Flex column style={{ width: '368px', margin: 'auto' }}>
          <Flex mb={20}>
            <Text fontSize="22px" bold>
              {this.props.title}
            </Text>
          </Flex>
          <Flex alignItems="center">
            Employee has not yet submitted the form.
          </Flex>
        </Flex>
      </Flex>
    );
  }

  renderFormNotReady() {
    return (
      <Flex column>
        <Flex column style={{ width: '368px', margin: 'auto' }}>
          <Flex mb={20}>
            <Text fontSize="22px" bold>
              {this.props.title}
            </Text>
          </Flex>
          <Flex alignItems="center">
            WOTC form not ready yet. Please try again later.
          </Flex>
        </Flex>
      </Flex>
    );
  }

  render() {
    this.isOnboardingV2 = isOnboardingV2 === 'true';

    const { action, previewMode, companyStaff } = this.props;
    const { wotc_url: iframeURL } = action;

    if (previewMode) return this.renderNotSubmitted();
    if (companyStaff && companyStaff.id) return this.renderNotSubmitted();
    if (!iframeURL) return this.renderFormNotReady();

    return (
      <Flex column>
        {
          this.isOnboardingV2 && <PageTitle title={this.props.action.module_name} />
        }
        <Flex column style={this.isOnboardingV2 ? { width: '100%', paddingLeft: '4px', paddingRight: '4px' } : { width: "100%", margin: "auto" }}>
          {
            !this.isOnboardingV2
              && <Flex mb={20}><Text fontSize="22px" bold>{this.props.title}</Text></Flex>
          }
          {this.state.loading && (
            <Loading className="spinner spinner-blue" />
          )}
          <iframe
            id="wotc-iframe"
            title='WOTC Form'
            src={iframeURL}
            style={{
              border: 'none',
              width: '100%',
              height: '100%',
              minHeight: '800px',
              display: 'block',
            }}
            onLoad={() => this.setState({ loading: false })}
          />
        </Flex>
      </Flex>
    );
  }
}

export default FillFormAction;
